export default "__VITE_ASSET__BgSTJ7pt__"